import React from 'react';
import {Flex, Text, VStack, Link, Skeleton} from '@chakra-ui/react';
import {ObjectId} from 'bson';
import {useAccountWithLogo} from '../../../hooks/api/accountWithLogo';

export const BuilderPreviewJumpToMenu = ({
  accountIds,
  containerRef,
  getItemRef,
}: {
  accountIds: ObjectId[];
  getItemRef: (item: ObjectId) => React.RefObject<HTMLElement>;
  containerRef: React.RefObject<HTMLElement>;
}) => {
  const handleClick = (item: ObjectId) => {
    const itemRef = getItemRef(item).current;
    const container = containerRef.current;

    if (itemRef && container) {
      // Get the position of the item relative to the container
      const containerRect = container.getBoundingClientRect();
      const itemRect = itemRef.getBoundingClientRect();

      // Calculate the scroll position
      const scrollTop = itemRect.top - containerRect.top + container.scrollTop;

      // Scroll to the item with smooth animation
      container.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Flex direction="column" overflow="auto" h="100%" w="160px" gap="2">
      <Text fontSize="sm" color="kgray.300" textTransform="uppercase">
        Jump to
      </Text>

      <VStack align="flex-start" gap="0" pr="2" overflowY="auto">
        {accountIds.map((accountId) => (
          <Link
            key={accountId.toString()}
            onClick={() => handleClick(accountId)}
            color="kgray.500"
            _hover={{color: 'kblue.500'}}
            py="4"
            w="100%"
          >
            <JumpToMenuItem accountId={accountId} />
          </Link>
        ))}
      </VStack>
    </Flex>
  );
};

const JumpToMenuItem = ({accountId}: {accountId: ObjectId}) => {
  const {data: account, isPending} = useAccountWithLogo(accountId);
  if (!account || isPending) {
    return <Skeleton height="5" width="75%" speed={0} />;
  }

  return (
    <Text noOfLines={1} wordBreak="break-all">
      {account.name}
    </Text>
  );
};
